import { TableData } from "types/components";
import { GetUsersFunctionParams } from "types/functions";

export const INITIAL_TITLE_COMAPNY_TABLE_DATA: TableData = {
  headers: [
    {
      title: "Company Name",
      key: "title_company",
    },
    {
      title: "Company Address  ",
      key: "company_address",
    },

    {
      title: "Phone Number",
      key: "phone_no",
    },
    {
      title: "Email",
      key: "email",
    },
    {
      title: "Territory",
      key: "territory",
    },
   
    {
      title: "Action",
      key: "action",
    },
  ],
  data: [],
};

export const INITIAL_GET_TITLE_COMPANY_PARAMS: GetUsersFunctionParams = {
  isVendor: undefined,
  isListingSpecialist: undefined,
  isAdmin: undefined,
};

export enum UserFilter {
  ALL = "all",
  SPECIALISTS = "specialists",
  VENDORS = "vendors",
  ADMINS = "admins",
}
